import Model from './../../zviz2/zviz/model';
import ModelCollection from './../../zviz2/zviz/modelcollection';
import state from './../../zviz2/zviz/state';
import {extend} from './../../zviz2/zviz/functions';

class ModelPack extends Model{

    constructor(name=null, settings={}){

        settings = extend(settings, {
            data: [],
        });

        super(name, settings);
        this.status = 'success';
        this.cache = false;

        this.rawData = settings.data;
        
        this.fetchData();
    }

    getSelect(){
        return {};
    }

    fetchData(){
        this.setData(this.compileData());
    }

    compileData(){
        let data = [];
        let total = 0;
        let max = 0;
        let min = Infinity;
        for(var p = 0; p < this.rawData.length; p++){
            let value = parseInt(this.rawData[p].value);
            data.push({
                type: 'theme',
                id: this.rawData[p].id,
                name: this.rawData[p].title,
                value: value,
                color: this.rawData[p].color,
                icon: this.rawData[p].icon,
                children: false
            });
            total += value;
            if(value > max){
                max = value;
            }
            if(value < min){
                min = value;
            }
        }
        for(let i = 0; i < data.length; i++){
            let scale = (max==min)? 1: (data[i].value - min) / (max - min);
        }
        return {children: data, value: total};
    }

}


// let BlueprintData = {children: [
//     {
//         type: 'dim1',
//         name: 'item1',
//         value: 20,
//         color: [255,0,0] // [r,g,b] or [r,g,b,a] (alpha will be ignored)
//         children: [
//             {
//                 type: 'dim2',
//                 name: 'item1a'
//                 value: 4,
//                 color: [255,0,0]
//             },
//             ....
//         ];
//     },
//     ....
//   ],
//   value: 200 
// }


ModelCollection.setModelClass('pack', ModelPack);

export default ModelPack;